export default () => window.document.scrollingElement || window.document.body;



// WEBPACK FOOTER //
// ./src/lib/dom/element-scroll.js